import { SelectOptionValues } from "../../../models/SelectOptionKeyValuePair";

class UnitOptions {
    public static SI: SelectOptionValues = {key: 0, value: "kW"}
    public static US: SelectOptionValues = {key: 1, value: "HP"} 
}

export default UnitOptions;